$(document).on('turbolinks:load', () => {
  const isSearchPage = window.location.href.includes('Search');
  if (isSearchPage) {
    window.location.href = window.location.href.concat('#search_results');
  }
});
